import React, {
  useState,
  useContext,
  useEffect,
}                               from 'react';
import { historyPropType }      from '~/config/routerPropTypes';
import Request                  from '~/providers/Request';
import Cards                    from './context';
import Form                     from './Form';
import { showCards }            from '~/config/routes';
import CardRecord               from '~/records/CardRecord';

function CardsForm({history}){
  const [ record, setRecord] = useState(new CardRecord());
  const [ loading, setLoading] = useState(false);
  const { records, addRecords } = useContext(Cards);
  const { id } = history.location.route.getParams();

  useEffect(() => {
    async function fetchData(id){
      if(records && records[id]){
        record.updateAttributes(records[id]);
      }
      setLoading(true);
      Request.get(`/admin/promo_cards/${id}`, {})
      .then(response => {
        setLoading(false);
        addRecords({ data: [response.data] }); //Array para reusar o util de transformar e jogar no contexto.
        setRecord(record.updateAttributes(response.data));
      })
      .catch( e => {
        console.error(e);
        setLoading(false);
      });
    }

      fetchData(id);
  }, []);

  async function onSubmit (hasImage=false){
    let data = {};
    if(hasImage){
      let archive_id = record.get('archive_id') ? record.get('archive_id') : null;
      const imageBase64 = record.get('image_base64');
      setLoading(true);
      if(imageBase64){
        try {
          const result = await Request.post('/upload_base64', { file: `data:image/jpg;base64,${imageBase64}` });
          archive_id = result.data.id;
        } catch(e) {console.log(e);}
      }
      data = record.toParams({archive_id});
    }

    if (!hasImage){
      data = record.toParams({archive_id: record.get('image') ? record.get('image').id : null});
    }
    Request.put(`/admin/promo_cards/${id}`, data, {}, { controller: 'cards' })
      .then((resp) => {
        setLoading(false);
          history.push(showCards.reverse(resp.data));
        })
      .catch(e => {
        console.error(e);
        setLoading(false);
      });
  }

    const handleChange = (attrs) => {
      setRecord(record.updateAttributes(attrs));
    };

  return(
    <Form
      onSubmit={onSubmit}
      handleChange={handleChange}
      loading={loading}
      record={record}
      setRecord={setRecord}
    />
  );
}

CardsForm.propTypes={
  history: historyPropType,
};

export default CardsForm;
